import type { Templates } from '../types/download.type';

export const DOWNLOAD_TEMPLATES = {
  exchange: {
    default: 'comprobante_transferencia_exchange_b2b.html',
    CO: 'comprobante_transferencia_exchange_col_b2b.html',
    AR: 'comprobante_transferencia_exchange_arg_b2b.html',
  },
  currencyCloudReception: {
    default: 'comprobante_transferencia_b2b.html',
    CO: 'comprobante_transferencia_col_b2b.html',
  },
  p2p: {
    default: 'comprobante_transferencia_p2p_b2b.html',
    CO: 'comprobante_transferencia_p2p_col_b2b.html',
    AR: 'comprobante_transferencia_p2p_arg_b2b.html',
  },
  pse: {
    default: 'comprobante_pago_pse_col.html',
  },
  stablecoinReception: {
    default: 'comprobante_recepcion_stablecoin_b2b.html',
  },
  stablecoinPayout: {
    default: 'comprobante_envio_stablecoin_b2b.html',
  },
} as const satisfies Templates;
